
import { db } from "../../firebaseClient";
import type { DailySummaryResult } from "./dailySummaryService";
import { computeDashboardSummary, TodoItem } from "./todosSummary";

export type { TodoItem };

// Subscribe to ALL Open Todos
export function subscribeDashboardTodos(
  onUpdate: (result: DailySummaryResult) => void,
  onError?: (error: any) => void
) {
  // Query: todoStatus == 'OPEN'
  const q = db.collection("todos")
    .where("todoStatus", "==", "OPEN")
    .orderBy("updatedAt", "desc")
    .limit(200);

  return q.onSnapshot(
    (snapshot) => {
      const todos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as TodoItem[];
      
      const result = computeDashboardSummary(todos);
      onUpdate(result);
    },
    (error) => {
      console.error("[TodosService] Subscription error:", error);
      if (onError) onError(error);
    }
  );
}

// Fetch ALL Open Todos Once (Polling Fallback)
export async function getDashboardTodosOnce(): Promise<DailySummaryResult> {
  const q = db.collection("todos")
    .where("todoStatus", "==", "OPEN")
    .orderBy("updatedAt", "desc")
    .limit(200);
  
  const snapshot = await q.get();
  const todos = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  })) as TodoItem[];
  
  return computeDashboardSummary(todos);
}

// Re-export for backward compatibility if needed, though direct usage should move to todosSummary
export { computeDashboardSummary as groupTodosForDashboard } from "./todosSummary";
